import { render, staticRenderFns } from "./FundReportsList.vue?vue&type=template&id=2b1f13ce&"
import script from "./FundReportsList.vue?vue&type=script&lang=js&"
export * from "./FundReportsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports